package pl.decks.posthog.client

import kotlinx.serialization.Serializable

@Serializable
abstract class PostHogEvent(val name: String)
